import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";

const useStyles = makeStyles(
  () => ({
    dialogContent: {
      display: "inline-block"
    },
    reasonLabel: {
      marginRight: "20px",
      width: "20%"
    },
    reasonTextField: {
      "& textarea": {
        minHeight: "152px"
      },
      width: "80%"
    },
    rejectBtn: {
      "& span": {
        color: "#fff"
      },
      background: "#F64E88"
    }
  }),
  { name: "RejectBatchDialog" }
);

interface RejectBatchDialogProps {
  open: boolean;
  onClose: () => void;
  onClickReject?: (data: string) => void;
}

function RejectBatchDialog(props: RejectBatchDialogProps) {
  const { onClickReject, onClose, open } = props;
  const classes = useStyles(props);
  const [inputVal, setInputVal] = useState<string>("");

  const handleInput = (event: React.ChangeEvent<any>) => {
    setInputVal(event.target.value);
  };

  return (
    <Dialog fullWidth onClose={onClose} open={open} maxWidth="xs">
      <DialogTitle>Reason for Rejection</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <label className={classes.reasonLabel}>Reason</label>
        <TextField
          className={classes.reasonTextField}
          multiline
          name="reason"
          defaultValue={inputVal}
          inputProps={{
            maxLength: 250
          }}
          onChange={handleInput}
        />
        <label>{`${inputVal.length}/250`}</label>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          className={classes.rejectBtn}
          disabled={inputVal.length === 0}
          onClick={() => onClickReject(inputVal)}
        >
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RejectBatchDialog;
